module.exports = __webpack_public_path__ + "media/images/xc_8-546b6f14021f7c5bd304958eee55ccde.png";